import { Box } from '@mui/material';
import videoDialogIcon from 'app/assets/icons/video-dialog.svg';
import VideoDialogIcon from 'app/assets/icons/video-dialog.svg?react';
import ArrowIcon from 'app/assets/icons/arrow.svg?react';
import { PrimaryButton, WhiteButton } from 'app/shared-components/buttons';
import useAppointmentVideoCall from 'app/pages/Appointments/hooks/useAppointmentVideoCall';
import { convertISODateToDayJsWithTimezone } from 'app/utils';

const getAppointmentStatusText = (appointment) => {
  const startTime = convertISODateToDayJsWithTimezone(
    appointment.startDate,
    appointment.timezone
  ).format('HH:mm');
  const endTime = convertISODateToDayJsWithTimezone(
    appointment.endDate,
    appointment.timezone
  ).format('HH:mm');
  const timeRange = `(${startTime} - ${endTime})`;

  if (appointment.isInProgress) {
    return `Video consultation is in progress ${timeRange}`;
  }

  const timeRemaining = appointment.startsInSeconds > 60
    ? `${Math.floor(appointment.startsInSeconds / 60)} minutes`
    : `${appointment.startsInSeconds} seconds`;

  return `Video consultation starts in ${timeRemaining} ${timeRange}`;
};

const VideoCallNotification = ({
  videoCall,
  onMoreButtonClick,
  showAllVideoCalls,
}) => {
  const iconFilter = videoCall?.isInProgress
    ? 'brightness(0) invert(1)'
    : 'brightness(0) saturate(100%) invert(64%) sepia(98%) saturate(440%) hue-rotate(92deg) brightness(91%) contrast(86%)';

  const { willBeAvailable, isDisabled, disabledReason, joinVideoCall } =
    useAppointmentVideoCall(videoCall);

  const showVideoCallButton = willBeAvailable === true || typeof joinVideoCall === 'function';

  const backgroundColor = videoCall && videoCall.isInProgress ? '#A72A2A' : 'black';

  return (
    <Box
      className="w-full flex items-center justify-between px-[25px] py-[10px] text-white"
      sx={{ backgroundColor, minHeight: '48px', marginBottom: '1px' }}
    >
      <Box className="flex items-center gap-10">
        <img
          src={videoDialogIcon}
          className="h-20"
          alt="Video call icon"
          style={{
            filter: iconFilter
          }}
        />
        <Box className="flex flex-col justify-center">
          <Box className="text-[14px] font-bold">
            {getAppointmentStatusText(videoCall)}
          </Box>
          <Box className="text-[12px] text-gray-300">
            {videoCall.patientFullName} - {videoCall.serviceName}
          </Box>
        </Box>
      </Box>
      <Box className="flex items-center gap-10">
        {onMoreButtonClick && (
          <WhiteButton
            label={showAllVideoCalls ? "Show Less" : "Show More"}
            icon={
              <Box sx={{ transform: showAllVideoCalls ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.3s' }}>
                <ArrowIcon />
              </Box>
            }
            cb={onMoreButtonClick}
          />
        )}
        {showVideoCallButton && (
          videoCall?.isInProgress ? (
            <WhiteButton
              label="Join call"
              icon={<VideoDialogIcon />}
              cb={joinVideoCall}
            />
          ) : (
            <PrimaryButton
              label="Join call"
              icon={<VideoDialogIcon />}
              cb={joinVideoCall}
              disabled={isDisabled}
              disabledText={disabledReason}
            />
          )
        )}
      </Box>
    </Box>
  );
};

export default VideoCallNotification;

